// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"aff92c76","726":"efef498f"}[chunkId] + ".chunk.js";
};